module.exports = __webpack_public_path__ + "static/favicon-18c53cec1d5af09143fa9b5ff7e1a100.ico";